import {
  Button,
  Stack,
  Typography,
  CircularProgress,
  Box,
} from "@mui/material";
import PropTypes from "prop-types";
import { useState } from "react";
import Iconify from "../iconify";
import { post } from "src/utils/networkUtils";
import { fDateTime } from "src/utils/formatTime";
const getSeasonTypeName = (seasonTypeId) => {
  switch (seasonTypeId) {
    case 1:
      return "10-games";
    case 2:
      return "21-games";
    case 3:
      return "40-games";
    default:
      return "Unknown";
  }
};
export default function GameControls({
  userId = 1,
  onPlayGame,
  onCompleteSeason,
  season,
  gameLoading = false,
  handleGetSeason,
}) {
  const [joiningGameId, setJoiningGameId] = useState(null);

  const handleJoinGame = (seasonTypeId) => {
    setJoiningGameId(seasonTypeId);
    post(`/admin/versus/users/${userId}/season-join`, {
      versusSeasonTypeId: seasonTypeId,
    })
      .then(function (response) {
        handleGetSeason();
      })
      .catch(function (error) {
        console.error("Error joining game:", error);
        setJoiningGameId(null);
      });
  };
  console.log("GameControls season:", season);
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      mb={2}
    >
      {season.season && (
        <>
          <Typography variant="h6" gutterBottom>
            Season: {getSeasonTypeName(season.season.versusSeasonTypeId)}. Ends:{" "}
            {fDateTime(season.season.endsAt)}
          </Typography>
          {season?.nextOpponentUsername ? (
            <Button
              variant="contained"
              startIcon={
                gameLoading ? null : <Iconify icon="eva:play-circle-outline" />
              }
              onClick={onPlayGame}
              disabled={gameLoading}
              sx={{ minWidth: 200 }}
            >
              {gameLoading ? (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
                  Processing...
                </Box>
              ) : (
                `Game ${season?.nextGameSequence} vs ${season?.nextOpponentUsername}`
              )}
            </Button>
          ) : (
            <Button
              variant="contained"
              startIcon={
                gameLoading ? null : <Iconify icon="eva:arrow-back-outline" />
              }
              onClick={onCompleteSeason}
              disabled={gameLoading}
              sx={{ minWidth: 200 }}
            >
              {gameLoading ? (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
                  Processing...
                </Box>
              ) : (
                `Select a New Season`
              )}
            </Button>
          )}
        </>
      )}

      {!season.season && (
        <>
          <Button
            variant="outlined"
            startIcon={
              joiningGameId === 1 ? null : (
                <Iconify icon="eva:refresh-outline" />
              )
            }
            onClick={() => handleJoinGame(1)}
            disabled={joiningGameId !== null}
          >
            {joiningGameId === 1 ? (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
                Joining...
              </Box>
            ) : (
              "Join 10-games"
            )}
          </Button>
          <Button
            variant="outlined"
            startIcon={
              joiningGameId === 2 ? null : (
                <Iconify icon="eva:refresh-outline" />
              )
            }
            onClick={() => handleJoinGame(2)}
            disabled={joiningGameId !== null}
          >
            {joiningGameId === 2 ? (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
                Joining...
              </Box>
            ) : (
              "Join 21-games"
            )}
          </Button>
          <Button
            variant="outlined"
            startIcon={
              joiningGameId === 3 ? null : (
                <Iconify icon="eva:refresh-outline" />
              )
            }
            onClick={() => handleJoinGame(3)}
            disabled={joiningGameId !== null}
          >
            {joiningGameId === 3 ? (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
                Joining...
              </Box>
            ) : (
              "Join 40-games"
            )}
          </Button>
        </>
      )}
    </Stack>
  );
}

GameControls.propTypes = {
  userId: PropTypes.number,
  onPlayGame: PropTypes.func.isRequired,
  season: PropTypes.object,
  gameLoading: PropTypes.bool,
};
